import * as BN from 'bn.js';
import { makeCurrencyFormatter } from '../formatters/utils';
import store from './store';
const defaultConfig = {
  symbol: 'USD',
  symbolInFront: false,
  precision: 2,
  withCurrency: true
};
const fiatFormatter = makeCurrencyFormatter(defaultConfig);
export const formatCurrencyInFiat = (currency, config) => {
  var _getState$currency$to;

  const {
    getState
  } = store;
  const exchangeRate = (_getState$currency$to = getState()[currency.token]) === null || _getState$currency$to === void 0 ? void 0 : _getState$currency$to.price;

  if (exchangeRate === undefined) {
    return '';
  }

  const precision = (config === null || config === void 0 ? void 0 : config.precision) || defaultConfig.precision;
  const multiplier = Math.pow(10, precision);
  const exchangedRateMultiplied = exchangeRate * multiplier;
  const fiatCurrency = { ...currency,
    value: new BN.BN(currency.value).muln(exchangedRateMultiplied).divn(multiplier).toString()
  };
  return fiatFormatter(fiatCurrency, config);
};